const RECEIVER = {
    onReady() {
        RECEIVER.pause();
        RECEIVER.update();
    },
    pause() {
        const button = document.getElementById('receiver-pause');
        if (button === null) return;
        button.addEventListener('click', event => {
            event.preventDefault();
            const form = button.closest('form');
            console.log(FORM.serialize(form));
        });
    },
    update() {
        const button = document.getElementById('receiver-update');
        if (button === null) return;
    },
    unsubscribe(that, event) {
        event.preventDefault();
        let queryString = window.location.search;
        let urlParams   = new URLSearchParams(queryString);
        let email       = urlParams.get('email');
        let mailing     = urlParams.get('mailing-id');
        // Mailer Logic
        let getUrl      = window.location;
        let baseUrl     = getUrl.protocol + '//' + getUrl.hostname + '/';
        var formData    = FORM.serialize(that.closest('form')) + '&email='+email+'&mailing_id='+mailing; // Add email and mailing_id as this because it is encrypted in the formData
        let handler     = 'handler.XHR.php?handler=receiver-unsubscribe';
        let xhr         = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    window.location.href = that.href;
                }
            }
        };
        xhr.onerror = (e) => {
            var responseText = form.querySelector('.form__responses .error[data-response="error"]').innerHTML;
            var markup = '<div class="form--response error">' + responseText + '</div>';
            FORM.response(0, markup); // index = 0
            document.getElementById('overlay-loading').remove();
        };
        xhr.send(formData);
    }
}